export default __webpack_public_path__ + "static/Graphik-SemiboldItalic-Web-d996e0882f6495f94496ef2b98f10f73.eot";